import { forwardRef } from 'react'
import Image from 'next/image'

import aboutUsHeroImg from '../../../assets/backgrounds/about-us-hero.png'

import styles from './styles.module.scss'

export const AboutUsHero = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['section-container']} ref={ref}>
      <Image
        src={aboutUsHeroImg}
        className={styles['background-image']}
        fill
        sizes="100vw"
        alt="People at a table discussing"
        loading="eager"
      />
      <div className={styles['overlay']} />
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          <h2 className={styles['title']}>
            We were born to{' '}
            <span className={styles['decorated-title']}>reduce intercultural barriers</span> and to
            promote thriving work relationships.
          </h2>
          <p className={styles['subtitle']}>
            Olby fosters connections between Brazilian talent and international companies, boosting
            global tech careers.
          </p>
        </div>
      </div>
    </section>
  )
})

export default AboutUsHero
